import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { FileDown, ChevronRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Tally Export Reminder — surfaces which voucher types (Sales/Receipt/
 * Payment) haven't been exported for LAST full calendar month, without
 * opening the Tally Export page. Renders nothing once everything for that
 * month has been exported, or for roles that can't view exports.
 */
export default function TallyExportReminder() {
  const { user } = useAuth();
  const role = (user?.role || '').toLowerCase();
  const canView = role === 'admin' || role === 'accounts';
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!canView) return;
    let alive = true;
    axios.get(`${BACKEND_URL}/api/tally/export/reminder`, { withCredentials: true })
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, [canView]);

  if (!canView || !data || !data.missing || data.missing.length === 0) return null;

  return (
    <Link
      to="/reports/tally-export"
      data-testid="tally-export-reminder-chip"
      className="flex items-center gap-2.5 rounded-xl border border-sky-200 bg-sky-50 px-4 py-3 text-sky-900 hover:bg-sky-100 transition-colors"
    >
      <FileDown className="h-4 w-4 shrink-0 text-sky-600" />
      <span className="text-sm font-semibold" data-testid="tally-export-reminder-text">
        {data.monthLabel}: {data.missing.join(', ')} voucher{data.missing.length === 1 ? '' : 's'} not yet exported to Tally
      </span>
      <ChevronRight className="h-4 w-4 ml-auto shrink-0 text-sky-500" />
    </Link>
  );
}
